import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IVenteListModal, ITarget } from '../../types/interfaces';
import VenteListTable from '../vente_list/VenteListTable';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import Loading from '../Loading';

const VenteListModal = ({ 
  modal,
  setModal,
  lines,
  linesLoading,
 }: IVenteListModal) => {
  
  const modalHandleToggle = () => setModal(!modal);

  return (
    <div>
      <Modal isOpen={modal} toggle={modalHandleToggle} className="modal-dialog-extra-large">
        <ModalHeader toggle={modalHandleToggle}><FontAwesomeIcon icon={faList} />&nbsp;&nbsp;Liste des ventes</ModalHeader>
        <ModalBody>
          {linesLoading ? <Loading topSpace /> : <VenteListTable ventesData={lines} showProjectColumn allAssociationsShown />}
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(VenteListModal);
